// ** Icons Import
import {Settings, Circle, Users, Copy} from 'react-feather'


export default [
    {
        header: 'navigation.administration',
        action: 'ROLE_ADMINISTRATION_',
        resource: 'IS_GRANTED'
    },
    {
        id: 'administration-parking',
        title: 'navigation.parking',
        icon: <Copy size={20}/>,
        navLink: '/administration/parking',
        action: 'ROLE_ADMINISTRATION_PARKING',
        resource: 'IS_GRANTED'
    },
    {
        id: 'administration-user',
        title: 'navigation.users',
        icon: <Users size={20}/>,
        navLink: '/administration/users',
        action: 'ROLE_ADMINISTRATION_USER',
        resource: 'IS_GRANTED'
    },
    {
        id: 'administration-log',
        title: 'navigation.logs',
        icon: <Settings size={20}/>,
        navLink: '/administration/log/symfony-log',
        action: 'ROLE_ADMINISTRATION_LOGS_',
        resource: 'IS_GRANTED',
        children: [
            {
                id: 'administration-log-symfony-log',
                title: 'navigation.symfony_logs',
                navLink: '/administration/log/symfony-log',
                icon: <Circle size={12}/>,
                action: 'ROLE_ADMINISTRATION_LOGS_SYMFONY',
                resource: 'IS_GRANTED'
            },
            {
                id: 'administration-log-system-log',
                title: 'navigation.system_log',
                navLink: '/administration/log/system-log',
                icon: <Circle size={12}/>,
                action: 'ROLE_ADMINISTRATION_LOGS_SYSTEM',
                resource: 'IS_GRANTED'
            }
        ]
    }
]